import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight, Shuffle } from 'lucide-react';

const Navigation = ({ onPrevious, onNext, onRandom, canGoPrevious, canGoNext }) => {
  return (
    <div className="flex items-center justify-center space-x-4" data-testid="navigation">
      <Button
        onClick={onPrevious}
        disabled={!canGoPrevious}
        variant="outline"
        size="lg"
        data-testid="previous-button"
      >
        <ChevronLeft className="w-5 h-5 mr-2" />
        Previous
      </Button>

      <Button
        onClick={onRandom}
        variant="outline"
        size="lg"
        data-testid="random-button"
      >
        <Shuffle className="w-5 h-5 mr-2" />
        Random
      </Button>

      <Button
        onClick={onNext}
        disabled={!canGoNext}
        variant="outline"
        size="lg"
        data-testid="next-button"
      >
        Next
        <ChevronRight className="w-5 h-5 ml-2" />
      </Button>
    </div>
  );
};

export default Navigation;